import { makeStyles } from '@material-ui/styles'
import { pageContentHorizontalGutters } from 'lib/styles/page-content-gutters'

const useStyles = makeStyles(theme => ({
  root: pageContentHorizontalGutters(theme, {
    margin: '60px 0px',
  }),
  select: {
    margin: '0 0 30px',
    maxWidth: '300px',
  },
}))

export default useStyles
